import React from "react";
import QuestionRadioInputOption from "@/components/page/QuestionRadioInputOption";

export default function QuestionRadioInput( props ) {
    return (
        <div className="-space-y-px rounded-md bg-white">
            { props.data.options.map(option => (
                <QuestionRadioInputOption key={option.id} option={option} data={props.data} value={props.value} disabled={props.disabled} onChange={props.onChange}/>
            ))
            }
        </div>
    )
}